/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ICartInfo, ICustomEvent, IPageViewInfo, IProductTransaction } from '../../interfaces';

/***
 * Enum type to represent supported telemetry events.
 */
export enum TelemetryEvent {
    PageView = 'PageView',
    ProductPageView = 'ProductPageView',
    AddToCart = 'AddToCart',
    RemoveFromCart = 'RemoveFromCart',
    UpdateInCart = 'UpdateInCart',
    CheckOut = 'CheckOut',
    Purchase = 'Purchase',
    Custom = 'Custom'
}

/***
 * Union type of content types accepted by the logEvent() API.
 */
export type TelemetryEventContent =
    | IPageViewInfo // PageView
    | ICartInfo // ProductPageView, AddToCart, RemoveFromCart, UpdateInCart, CheckOut
    | IProductTransaction // Purchase
    | ICustomEvent; // Custom
